module.exports = __webpack_public_path__ + "6b6e6dc237c8b02fa5a835a521baa08e.svg";